import { Box } from '@mui/material'
import { t } from 'i18next'
import { SwitchField } from 'src/components/shared/ui/form/fields'
import { FormField } from 'src/enums/Form'

function ReclamacionConsumidor(): JSX.Element {
  return (
    <Box display="flex" flexDirection="row" sx={{ margin: '16px 0px 0px 16px', width: '100%' }}>
      <SwitchField
        id={FormField.DATOS_RECLAMACION_CONSUMIDOR}
        label={t('components.reclamacion_consumidor.text')}
      />
    </Box>
  )
}

export default ReclamacionConsumidor
